import { ASSET_CATALOG_SKELETON_ROWS } from '@/features/admin-dashboard/config/assetCatalog';
import { Skeleton } from '@/shared/components/ui/skeleton';

/**
 * Cold-load placeholder for the catalog table. Shape-matched to `AssetCatalogTable`
 * (bordered container, `h-8` header row, `h-9` body rows) so the route's
 * `pendingComponent` and the list view's `pending` arm resolve to the same visual.
 */
export function AssetCatalogTableSkeleton() {
  return (
    <div className="overflow-hidden rounded-md border">
      <div className="flex h-8 items-center gap-3 border-b bg-muted/30 px-1.5">
        <Skeleton className="h-3 w-16" />
        <Skeleton className="h-3 w-24" />
        <Skeleton className="h-3 w-32" />
        <Skeleton className="h-3 w-14" />
      </div>
      {Array.from({ length: ASSET_CATALOG_SKELETON_ROWS }, (_, index) => index).map((index) => (
        <div key={index} className="flex h-9 items-center gap-3 border-b px-1.5 last:border-b-0">
          <Skeleton className="h-3 w-16" />
          <Skeleton className="h-3 w-24" />
          <Skeleton className="h-3 flex-1" />
          <Skeleton className="h-3 w-14" />
        </div>
      ))}
    </div>
  );
}
